// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import { LocationProvider, Router, Route } from 'preact-iso';
import { SessionProvider } from './session-context.js';
import { Layout } from './components/layout.js';
import { ErrorBoundary } from './components/error-boundary.js';
import { Home } from './pages/home.js';
import { Vaults } from './pages/vaults.js';
import { Accept } from './pages/accept.js';
import { VaultDetail } from './pages/vault-detail.js';
import { SharedVaults } from './pages/shared-vaults.js';
import { SharedVaultCreate } from './pages/shared-vault-create.js';
import { SharedVaultAccept } from './pages/shared-vault-accept.js';
import { SharedVaultDetail } from './pages/shared-vault-detail.js';
import { Wallet } from './pages/wallet.js';
import { SignVerifierChallenge } from './pages/sign-verifier-challenge.js';
import { AccountAbandon } from './pages/account-abandon.js';
import { AbandonConfirm } from './pages/abandon-confirm.js';
import { VerifyEmail } from './pages/verify-email.js';
import { PlatformTerms } from './pages/platform-terms.js';
import { NotFound } from './pages/not-found.js';

export function App() {
  return (
    <ErrorBoundary>
      <LocationProvider>
        <SessionProvider>
          <Layout>
            <Router>
              <Route path="/" component={Home} />
              <Route path="/vaults" component={Vaults} />
              <Route path="/accept" component={Accept} />
              <Route path="/vault/:id" component={VaultDetail} />
              {/* M2.5 Shared Vaults (epic COB-186). The accept landing
                  (/shared-vault/accept) must precede the /shared-vault/:id
                  detail route so the literal path wins over the param. */}
              <Route path="/shared-vaults" component={SharedVaults} />
              <Route path="/shared-vaults/create" component={SharedVaultCreate} />
              <Route path="/shared-vault/accept" component={SharedVaultAccept} />
              <Route path="/shared-vault/:id" component={SharedVaultDetail} />
              <Route path="/wallet" component={Wallet} />
              <Route
                path="/sign-verifier-challenge"
                component={SignVerifierChallenge}
              />
              {/* F12.A: lost-passcode-AND-lost-seed recovery flow. */}
              <Route path="/account/abandon" component={AccountAbandon} />
              <Route path="/abandon" component={AbandonConfirm} />
              {/* COB-340: email-verification magic-link landing. */}
              <Route path="/verify-email" component={VerifyEmail} />
              {/* COB-397: Cobault Platform Terms (browsewrap, footer link). */}
              <Route path="/platform-terms" component={PlatformTerms} />
              <Route default component={NotFound} />
            </Router>
          </Layout>
        </SessionProvider>
      </LocationProvider>
    </ErrorBoundary>
  );
}
